export default __webpack_public_path__ + "static/media/mouse-keyboard.96a1f12b.png";